import { render, staticRenderFns } from "./TemplatePreview.vue?vue&type=template&id=639445ca&scoped=true"
import script from "./TemplatePreview.vue?vue&type=script&lang=js"
export * from "./TemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./TemplatePreview.vue?vue&type=style&index=0&id=639445ca&prod&scoped=true&lang=scss"
import style1 from "./TemplatePreview.vue?vue&type=style&index=1&id=639445ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639445ca",
  null
  
)

export default component.exports